import React, { createContext, useContext, useEffect, useState } from "react";

const IsMobileContext = createContext(false);

export function IsMobileProvider({
  children,
  breakpoint = 768,
}: {
  children: React.ReactNode;
  breakpoint?: number;
}) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const update = (event?: MediaQueryListEvent) => {
      setIsMobile(event ? event.matches : mediaQuery.matches);
    };

    requestAnimationFrame(() => update());

    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, [breakpoint]);

  return (
    <IsMobileContext.Provider value={isMobile}>
      {children}
    </IsMobileContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useIsMobile() {
  return useContext(IsMobileContext);
}
